import { Modal, Row, Col, Button } from "antd";
import React from "react";

const DeleteGateModal = ({
  visible,
  setVisible,
  text,
  handleSubmit,
  loading,
}) => {
  return (
    <Modal
      className="candidateDeleteModal"
      centered
      getContainer={document.body}
      onCancel={() => setVisible(false)}
      open={visible}
      footer={null}
      title={`Remove ${text}(s)?`}
    >
      <Row className="header">
        <Col>
          <p className="desc">
            Are you sure you want to remove selected {text}(s)?
          </p>
        </Col>
      </Row>

      <Row align="middle" gutter={16} justify="end">
        <Col>
          <Button
            className="confirmBtn"
            onClick={() => handleSubmit(null)}
            loading={loading}
          >
            Remove
          </Button>
        </Col>
        <Col>
          <Button className="cancelBtn" onClick={() => setVisible(false)}>
            Cancel
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default DeleteGateModal;
